module.exports = __webpack_public_path__ + "img/banner-rain.02bdca75.png";